import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';
import { isNull } from "@/functions/Util";

export default class FormularioValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }

    validate(model, refs) {
        let validated = true;
        let formulario = model;

        if (isNull(model.idform_formularioerp)) {
            refs.idformularioerpInput.focusedOut = true;
            validated = false;
        }

        if (isNull(model.titulo)) {
            refs.tituloInput.focusedOut = true;
            validated = false;
        }
        if (isNull(model.descricao_geral)) {
            refs.descricaoInput.focusedOut = true;
            validated = false;
        }

        let validated2 = true;
        if (formulario.formGrupoPerguntaList) {
            let qtdGrupoPerguntas = 0;

            formulario.formGrupoPerguntaList.forEach(formGrupoPergunta => {

                if (formGrupoPergunta.datahoradel == null || formGrupoPergunta.datahoradel == undefined) {

                    qtdGrupoPerguntas++;

                    if (isNull(formGrupoPergunta.descricao)){
                        console.warn(`Validação falhou na descrição do grupo de perguntas: [${formGrupoPergunta.descricao}]`);
                        if (validated2) this.showMessage(new Message('alert', 'msg-descricao-ausente', true));
                        validated2 = false;
                    }
    
                    if (formGrupoPergunta.formPerguntaList) {
                        let qtdPerguntas = 0;
                        
                        formGrupoPergunta.formPerguntaList.forEach(formPergunta => {
                            if (formPergunta.datahoradel == null || formPergunta.datahoradel == undefined) {
                                qtdPerguntas++;

                                if (isNull(formPergunta.descricao)){
                                    console.warn(`Validação falhou na descrição da pergunta: [${formPergunta.descricao}]. Grupo de perguntas: [${formGrupoPergunta.descricao}]`);
                                    if (validated2) this.showMessage(new Message('alert', 'msg-descricao-ausente', true));
                                    validated2 = false;
                                }
                                if (formPergunta.formRespostaItemList.length == 0) {
                                    console.warn(`Validação falhou no grupo de respostas por não conter itens. Grupo de perguntas: [${formGrupoPergunta.descricao}]`);
                                    this.showMessage(new Message('error', 'msg-gr-sem-r', true));
                                    validated = false;
                                }
        
                                if (formPergunta.formRespostaItemList) {
                                    formPergunta.formRespostaItemList.forEach(formRespostaItem => {
                                        if (['SWITCH', 'RADIO', 'CHECKBOX', 'COMBOBOX'].includes(formPergunta.item_tipo)) {

                                            if (isNull(formRespostaItem.descricao) && !formRespostaItem.datahoradel){
                                                console.warn(`Validação falhou na descrição da resposta do grupo de respostas: [${formRespostaItem.descricao}]. Pergunta: [${formRespostaItem.descricao}]. Grupo de perguntas: [${formGrupoPergunta.descricao}]`);
                                                if (validated2)
                                                    this.showMessage(new Message('alert', 'msg-descricao-ausente', true));
                                                validated2 = false;
                                            }
                                        }

                                    });
                                }
                            }
                        });
                        
                        if (qtdPerguntas == 0) {
                            console.warn(`Validação falhou no grupo de perguntas [${formGrupoPergunta.descricao}] por não haver perguntas.`);
                            this.showMessage(new Message('error', 'msg-gp-sem-p', true));
                            validated = false;
                        }
                    } else {
                        console.warn(`Validação falhou no grupo de perguntas [${formGrupoPergunta.descricao}] por não haver perguntas.`);
                        this.showMessage(new Message('error', 'msg-gp-sem-p', true));
                        validated = false;
                    }
                }
                
            });

            if (qtdGrupoPerguntas == 0) {
                console.warn('Validação falhou por não ter ao menos um grupo de perguntas.');
                this.showMessage(new Message('error', 'msg-form-sem-gp', true));
                validated = false;
            }
        } 

        if (!validated2){
            validated = false;
        }
        return validated;
    }

}